import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { ErrorBindingService } from './../../services/error-binding.service';
import { UserCommonService } from './../../services/user-common.service';
import { StorageService } from '../../services/storage.service';
import { AppSettings } from '../../app.settings';


@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  passwordError = [{
    message: false
  }];
  @Input() changePasswordPopup: boolean;
  @Output() isShowChangePassword: EventEmitter<any> = new EventEmitter();
  @ViewChild('oldPassword') oldPassword: ElementRef

  chagePasswordForm = new UntypedFormGroup({
    oldPassword: new UntypedFormControl(),
    newPassword: new UntypedFormControl(),
    newConfirmPassword: new UntypedFormControl()
  });
  submitted: boolean;
  isPasswordMismatch = false;
  constructor(private formBuilder: UntypedFormBuilder,
    private signOutService: UserCommonService,
    private errorBindingService: ErrorBindingService,
    private storageService: StorageService) { }

  ngOnInit() {
    this.chagePasswordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required]],
      newConfirmPassword: ['', [Validators.required]]
    });
  }

  passwordNotMatched() {
    if (this.chagePasswordForm.controls.newPassword.value !== this.chagePasswordForm.controls.newConfirmPassword.value) {
      this.isPasswordMismatch = true
      document.getElementById('newPassword').focus();
    } else {
      this.isPasswordMismatch = false
      return true;
    }
  }

  requestData() {
    return {
      oldPassword: this.chagePasswordForm.controls.oldPassword.value,
      newPassword: this.chagePasswordForm.controls.newPassword.value,
    };
  }
  doChangePassword() {
    this.submitted = true;
    if (this.chagePasswordForm.valid && this.passwordNotMatched()) {
      const data = this.requestData();
      const userObj: any = this.storageService.getItem(AppSettings.USER_DETAILS);
      const userId = userObj.id;
      const c = this;
      this.signOutService.passwordChange(JSON.stringify(data), userId).subscribe(results => {
        if (results.general !== null && results.general !== undefined) {
          results.general.forEach(element => {
            this.errorBindingService.setMessage({ severity: 'success', summary: 'Success', detail: element.message });
          });
          setTimeout(() => {
            this.chagePasswordForm.reset();
            this.isShowChangePassword.emit(false);
          }, 2000);
        }
      }, (error) => {
        if (error.general !== null && error.general !== undefined) {
          error.general.forEach(element => {
            this.errorBindingService.setMessage({ severity: 'warn', summary: 'Error', detail: element.message });
          });
        }
      });
    } else {
      this.errorBindingService.getFormValidationErrors(this.chagePasswordForm);
    }
  }

  setFocus() {
    setTimeout(() => {
      this.oldPassword.nativeElement.focus()
    }, 50)
  }

  onCancel() {
    this.chagePasswordForm.reset();
    this.isShowChangePassword.emit(false);
  }
}
